/**
 * CleanScheduleCleanerAssignmentStatus enum
 * PrismaのCleanScheduleCleanerAssignmentStatus enumと同期させる必要があります
 * @see prisma/schema.prisma
 */
export enum CleanerAssignmentStatus {
  ASSIGNED = 'ASSIGNED',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
  /** 下書き (公開ボタンを押すまでスタッフに見せない) */
  DRAFT = 'DRAFT'
}

/**
 * 担当として数えない状態.
 * - DRAFT: 未公開の下書き. 公開するまでスタッフに見せない
 * - REJECTED: 本人が辞退した. 行は履歴のために残すが, 実際には稼働しない
 */
export const NON_ASSIGNED_STATUSES: CleanerAssignmentStatus[] = [
  CleanerAssignmentStatus.DRAFT,
  CleanerAssignmentStatus.REJECTED
]

/** その担当行を「担当がいる」として数えてよいか. */
export const isAssignedStatus = (status: string) =>
  !NON_ASSIGNED_STATUSES.some((s) => s === status)
